// NATIVE 
import React, { useEffect, useState } from 'react'


// INSTALLED 
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumbs, Button,  Grid, Typography } from '@mui/material';


// CUSTOM 
import { TableComponent } from '../../components/tables/TableComponent';
import { MiniCardGlobal } from '../../components/MiniCardGlobal';
import { Business, People, PeopleOutline, Person, PersonSearch } from '@mui/icons-material';
import { theme } from '../../commons/theme';
import { getCustomersStore } from '../../store/customer';
import { SnackAlert } from '../../components/SnackAlert';
import { hasPemissions } from '../../commons/utils';

export const Customer = () => {


  const dispatch = useDispatch();

   // REDUX
   const  {  customers_list }:any  = useSelector( (state:any) => state.customer );


  const [activos,   setActivos] = useState(0);
  const [vencidos,  setVencidos] = useState(0);
  const [inactivos, setInactivos] = useState(0);

  const [alert_snack, setAlertSnack] = useState(false);

  const [message_alert_snack, setMessageAlertSnack] = React.useState('');
  const [type_alert_snack, setTypeAlertSnack] = React.useState('success');
  

  // HERE LOAD THE DATA NECESARY FOR CREATE PARAMETERS 
  useEffect( () => {
      getDataCustomers();
  }, []);



  useEffect(() => {
    
    setActivos(customers_list.activosTotal);
    setVencidos(customers_list.vencidosTotal);
    setInactivos(customers_list.inactivosTotal);

  }, [customers_list]);
  


  const getDataCustomers = async() => {


                                             // permission_slug  // slug in childrens  // permission
    const havePermissions = await hasPemissions('modulo.manager', 'modulo.cliente',   'view');
    
    
        if( !havePermissions ){
    
          setAlertSnack(true);

          await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');

          setTypeAlertSnack('error')
    
          return false;
    
                                                                        
            
        }

    
    const response =  await dispatch( getCustomersStore() );


    if ( !response.ok && response.statusCode == 403 || response.code && response.code == 403) {

      setAlertSnack(true);

      await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');

      setTypeAlertSnack('error')

      return false;

    }

  
  }



  return (


    <>
    
       <SnackAlert open={alert_snack} onclick={setAlertSnack} text={message_alert_snack} severity={type_alert_snack}/>


       <div style={{ widows: '100%' }}>
        <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>Listado Cliente</Typography>
        <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
            <Typography color="textPrimary" sx={{ fontWeight: 700 }}>Manager</Typography>
            <Typography color="textPrimary">Clientes</Typography>
        </Breadcrumbs>

        

        <Grid container sx={{ marginBottom: 2 }}>

          <Grid item xs={4} sx={{ padding: 1 }}>
            <MiniCardGlobal
              title="Activos"
              count={activos}
              icon={<People fontSize="large" />}
              colorBgIcon={theme.palette.success.light}
              totalText='Total Clientes'
              colorTitle={'#5DCC0A'}
              bgTitle={'#E4F6D6'}
            />
          </Grid>

          <Grid item xs={4} sx={{ padding: 1 }}>
            <MiniCardGlobal
              title="Vencidos"
              count={vencidos}
              icon={<People fontSize="large"  />}
              colorBgIcon={theme.palette.warning.light}
              totalText='Total Clientes'
              colorTitle={'#FFB911'}
              bgTitle={'#FFF3D6'}
            />
          </Grid>


          <Grid item xs={4} sx={{ padding: 1 }}>
            <MiniCardGlobal
              title="Inactivos"
              count={inactivos}
              icon={<People fontSize="large"  />}
              colorBgIcon={theme.palette.error.light}
              totalText='Total Clientes'
              colorTitle={'#FF4C51'}
              bgTitle={'#FFE2E3'}
            />
          </Grid>

        </Grid>
        

        <div style={{ display: 'flex', justifyContent: 'end'}}>
           <Button component={Link} to={'/manager/crear-cliente'}  variant='contained' sx={{ marginBottom: 2, marginTop: 1 }}>Crear Cliente</Button>
        </div>
        

      
        
        <TableComponent />
    </div>


    </>
    
  )
}
